import type { CatalogueRoot } from "../../catalogue/types";
import { useLabels, useMapCore } from "../hooks";
import { Menu } from "../primitives/Menu";
import type { MenuItem } from "../primitives/Menu";

export type PanelMenuProps = {
  root?: CatalogueRoot | null;
  onCollapseAll?: (() => void) | null;
  onExpandAll?: (() => void) | null;
  className?: string;
};

export function PanelMenu({ root = null, onCollapseAll = null, onExpandAll = null, className }: PanelMenuProps) {
  const core = useMapCore();
  const labels = useLabels();

  const items: MenuItem[] = [
    { id: "all-on", label: labels.allOn, icon: "eye", run: () => core.layers.allOn(root, true) },
    { id: "all-off", label: labels.allOff, icon: "eyeOff", run: () => core.layers.allOn(root, false) },
    { id: "reset", label: labels.reset, icon: "undo", run: () => core.layers.reset() }
  ];

  if (onCollapseAll !== null) items.push({ id: "collapse-all", label: labels.collapseAll, icon: "collapseAll", run: onCollapseAll });
  if (onExpandAll !== null) items.push({ id: "expand-all", label: labels.expandAll, icon: "expandAll", run: onExpandAll });

  return <Menu label={labels.layersMenu} items={items.map((a, index) => ({ ...a, separatorBefore: index === 3 }))} className={className} dataFxmap="panel-menu" triggerDataFxmap="panel-menu-toggle" size="sm" />;
}
